import { performDeleteRequest } from '@atlassian/jira-servicedesk-common/src/utils/fetch/requests.tsx';
import type { Group, TicketType } from '../../common/types.tsx';

export const getDeleteRequestTypeUrl = (projectId: number, groups: Group[], id: number) => {
	const groupId = groups.length > 0 ? groups[0].id : 'hidden';
	return `/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${groupId}/request-types/${id}`;
};

export const deleteTicketTypeService = (
	ticketType: TicketType,
	projectId: number,
): Promise<void> => {
	const { groups, id } = ticketType;
	const url = getDeleteRequestTypeUrl(projectId, groups, id);

	return performDeleteRequest(url);
};
